import { render, staticRenderFns } from "./CenterRightReview1.vue?vue&type=template&id=43a69c6d&scoped=true"
import script from "./CenterRightReview1.vue?vue&type=script&lang=js"
export * from "./CenterRightReview1.vue?vue&type=script&lang=js"
import style0 from "./CenterRightReview1.vue?vue&type=style&index=0&id=43a69c6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a69c6d",
  null
  
)

export default component.exports